import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header, { SECTION_TABS } from './Header';

const PublicShell = () => {
  const { pathname } = useLocation();
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    if (pathname !== '/') {
      setActiveSection(null);
      return undefined;
    }

    const onScroll = () => {
      const current = SECTION_TABS.reduce((found, tab) => {
        const el = document.getElementById(tab.id);
        return el && el.getBoundingClientRect().top <= 140 ? tab.id : found;
      }, null);
      setActiveSection(current);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [pathname]);

  return (
    <>
      <Header links={SECTION_TABS} activeId={activeSection} />
      <Outlet />
    </>
  );
};

export default PublicShell;
